import type { FAIconName } from "@/ui/core/Icon";
import Icon from "@/ui/core/Icon/Icon";
import Text from "@/ui/core/Text";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { isNotNilNotEmpty } from "@/utils/shared.utils";
import { joinTestIDs } from "@/utils/string.util";

interface LabelWithIconProps extends ViewWithTestID {
  iconColor?: ColorToken;
  iconName: FAIconName;
  isDisabled?: boolean;
  text?: string;
}

const LabelWithIcon = ({
  iconColor,
  iconName,
  isDisabled,
  testID,
  text,
}: LabelWithIconProps) => {
  if (!isNotNilNotEmpty(text?.trim())) {
    return null;
  }

  const disabledColor = isDisabled ? ColorToken.NeutralTertiary : undefined;

  return (
    <HStack gap={8} testID={testID}>
      <Icon
        color={isDisabled ? disabledColor : iconColor}
        name={iconName}
        testID={joinTestIDs(testID, iconName)}
      />
      <Text color={disabledColor} testID={joinTestIDs(testID, "label")}>
        {text}
      </Text>
    </HStack>
  );
};

export type { LabelWithIconProps };
export default LabelWithIcon;
